import React, { ReactElement } from 'react';
import Spinner from "../loaders/Spinner";

interface ButtonProps extends React.ButtonHTMLAttributes<any> {
    icon: ReactElement;
    onClick: (event?: any) => void;
    className?: string;
    variant?: 'primary' | 'secondary' | 'tertiary' | 'light' | 'dark' | 'border' | 'plain'; // for plain all styling is external
    size?: 'small' | 'medium' | 'large' | 'short' | 'long';
    label?: string | number;
    loading?: boolean;
}

function ButtonIcon({ icon, onClick, variant = 'primary', size = 'small', label, className, loading, ...restProps }: ButtonProps) {
    return (
        <button
            className={`relative z-[1] inline-flex items-center justify-center ${variant === 'plain' ? className : `button_${variant} button_${size} mb-[8px] md:mb-0 h-9 w-9 rounded-full ${className || ''}`}`}
            onClick={onClick}
            disabled={loading} // Disable button while loading
            {...restProps}
        >
            {loading ? (
                <Spinner />
                ) : (
                icon  // Show icon when not loading
                )}

            {label && !loading && (
                <span className='absolute top-0 right-0 bg-orange-600 w-4 h-4 text-[10px] leading-[revert] text-center rounded-full'>
                    {label}
                </span>
            )}
        </button>
    );
}

export default ButtonIcon;
